import { render, staticRenderFns } from "./StagingTextSectionEditor.vue?vue&type=template&id=bdde0dca"
import script from "./StagingTextSectionEditor.vue?vue&type=script&lang=ts"
export * from "./StagingTextSectionEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports